import { ApiResponse } from "@apis/api.ts";

const PollingUtils = {
  /**
   * Function execute a function with fibonacci interval
   *
   * @param param - The parameters for promise function
   * @param fn - The polling promise function.
   * @param isContinueFn - The function that determines whether to continue polling.
   * @param startDateTime - The timestamp the first polling call was made.
   * @param maxDuration - The maximum duration that the polling should continue for.
   * @param startingInterval - The starting interval before retrying.
   * @param nextInterval - The next interval before retrying.
   * @returns {Promise}
   */
  pollingWithFibonacciInterval(
    param,
    fn,
    isContinueFn,
    startDateTime,
    maxDuration = 300000, // 5mins
    startingInterval = 5000,
    nextInterval = 8000,
  ): Promise<ApiResponse> {
    return new Promise((resolve, reject) => {
      return fn(param)
        .then((response) => {
          if (Date.now() - startDateTime >= maxDuration) {
            return reject();
          }
          if (!isContinueFn(response)) {
            // dont continue polling
            return resolve(response);
          }
          setTimeout(() => {
            this.pollingWithFibonacciInterval(
              param,
              fn,
              isContinueFn,
              startDateTime,
              maxDuration,
              nextInterval,
              startingInterval + nextInterval,
            ).then(resolve, reject); // Passing on "resolve/reject" is important
          }, startingInterval);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  },

  /**
   * Function execute a function with constant interval
   *
   * @param param - The parameters for promise function
   * @param fn - The polling promise function.
   * @param isContinueFn - The function that determines whether to continue polling.
   * @param startDateTime - The timestamp the first polling call was made.
   * @param maxDuration - The maximum duration that the polling should continue for.
   * @param Interval - The interval before retrying.
   * @returns {Promise}
   */
  pollingWithInterval(
    param,
    fn,
    isContinueFn,
    startDateTime,
    maxDuration = 300000, // 5mins
    interval = 5000,
  ) {
    return new Promise((resolve, reject) => {
      return fn(param)
        .then((response) => {
          if (Date.now() - startDateTime >= maxDuration) {
            return reject();
          }
          if (!isContinueFn(response)) {
            // dont continue polling
            return resolve(response);
          }
          setTimeout(() => {
            this.pollingWithInterval(
              param,
              fn,
              isContinueFn,
              startDateTime,
              maxDuration,
              interval,
            ).then(resolve, reject); // Passing on "resolve/reject" is important
          }, interval);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  },
};

export default PollingUtils;
